import GetMenuItemResponse from '../CRM/Responses/MenuItemResponse';

import Model from './Model';

export default class MenuItem extends Model {
    readonly id: number;
    readonly order: number;
    readonly name: string;
    readonly url: string;
    readonly class: string;
    readonly rel_nofollow: boolean = false;
    readonly menu_id: number;
    readonly parent_id: number = null;

    constructor(menuItem: Partial<GetMenuItemResponse>) {
        super();
        this.assignDataToProps(menuItem, [
            'id',
            'order',
            'name',
            'url',
            'class',
            'rel_nofollow',
            'menu_id',
            'parent_id',
        ]);
    }
}
